import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
@Component({
    selector: 'kh-video-player',
    templateUrl: './video-player.component.html',
    styleUrls: ['./video-player.component.less'],
    standalone: false
})
export class VideoPlayerComponent implements AfterViewInit {
  @ViewChild('videoPlayer') public videoPlayer!: ElementRef;
  public readonly sourceType = 'video/mp4';
  @Input() public videoSrc = '';
  @Input() public maxHeight = 'initial';
  @Input() public width = 'auto';
  @Input() public autoPlay = false;
  @Input() public pauseOrPlay = () => this.pauseOrPlayFunction();

  public ngAfterViewInit() {
    this.videoPlayer.nativeElement.onloadeddata = () => {
      this.videoPlayer.nativeElement.muted = true;
      if (this.autoPlay) {
        if(this.videoPlayer?.nativeElement.paused) {
          this.videoPlayer.nativeElement.play();
        }
      }
      else {
        if(!this.videoPlayer?.nativeElement.paused) {
          this.videoPlayer.nativeElement.pause();
        }
      }
    };
  }

  public videoScrValue(videoSrc: string): string {
    return `${videoSrc}#t=0.1`;
  }

  public pauseOrPlayFunction(): void {
    if (this.videoPlayer?.nativeElement.paused) {
      this.videoPlayer.nativeElement.muted = true;
      this.videoPlayer.nativeElement.play();
    } else if (this.videoPlayer) {
      this.videoPlayer.nativeElement.pause();
      this.videoPlayer.nativeElement.currentTime = 0;
    }
  }
}